export class GaApplicationsConfig {
    public productName: string;
    public defaultFavoritesIds: string[];

    constructor(options?: GaApplicationsConfig) {
        this.productName = options?.productName ?? '';
        this.defaultFavoritesIds = options?.defaultFavoritesIds ?? [];
    }
}

export const defaultGaApplicationsConfig: GaApplicationsConfig = {
    productName: 'Guru Admin',
    defaultFavoritesIds: []
};
